import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ErrorModal extends React.Component {

    constructor() {
        super();
        this.closeErrorModal = this.closeErrorModal.bind(this);

    }

    closeErrorModal() {
        if (this.props.goBack) {
            this.props.closeErrorModal()
            window.history.go(-1);
        }
        else if (this.props.direcionaURL) this.props.propsHistory.push(this.props.direcionaURL);
        else this.props.closeErrorModal();
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.isOpen} className={this.props.className}>
                    <ModalHeader toggle={this.closeErrorModal}>Ops, algo deu errado!</ModalHeader>
                    <ModalBody>
                        {this.props.message}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary" onClick={this.closeErrorModal}>Ok</button>{' '}
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ErrorModal;